import React from 'react'
import portfolio2 from '../images/hero.png'

const About = () => {
    return (
        < >
        <div className="about">
            <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-10 mx-auto">
                    <img src={portfolio2} alt="portfolio-2" className="img-fluid" />                        
                </div>
                <div className="col-lg-6 col-md-6 col-10 mx-auto">
                    <div className="about-content">
                    <h1>about me</h1>
                    <h4>I'm a passionate web designer</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe laborum incidunt,
                         tempore nostrum in fuga debitis beatae commodveniam quasi officia aut odit ad quam
                          officiis obcaecati dolore consectetur adipisicing elit. Saepe laborum incidunt,
                         tempore nostrum in fuga debitis beatae commodveniam quasi officia aut odit ad quam
                          officiis obcaecati dolore eligendi ipsam.</p>
                                    <button href="#" className="btn btn-default mb-4" id="btn__3"> View More Details</button>
                                    </div>
                                
                </div>
        </div>
        </div>
        </div>
        </>
    )
}

export default About
